export default __webpack_public_path__ + "static/media/pause-circle.3c7b5800.svg";